export default "__VITE_ASSET__8rniQ7oI__"